import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { validateUsername, validatePassword } from "../utils/validation";

export default function Login() {
    const location = useLocation();
    const navigate = useNavigate(); // ✅ add navigation hook
    const [form, setForm] = useState({ username: "", password: "" });
    const [errors, setErrors] = useState({});
    const [info, setInfo] = useState("");

    // Show success message after signup
    useEffect(() => {
        if (location.state?.signedUp) {
            setInfo("Account created successfully ✅ Please log in.");
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    function handleChange(e) {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    }

    function validateAll() {
        const newErrors = {
            username: validateUsername(form.username),
            password: validatePassword(form.password, form.username),
        };
        setErrors(newErrors);
        return Object.values(newErrors).every((err) => !err);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!validateAll()) return;

        // Simulated login with localStorage
        const saved = localStorage.getItem("demoUser");
        if (saved) {
            const user = JSON.parse(saved);
            const matched =
                (form.username === user.username || form.username === user.email) &&
                form.password === user.password;

            if (matched) {
                alert("Login successful 🎉 ");

                // ✅ Redirect to Sign-Up (or dashboard if needed)
                navigate("/signup");
                return;
            }
        }
        alert("Invalid credentials ❌");
    }

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
            <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-lg border-0 rounded-4">
                    <div className="card-body p-5">
                        <h2 className="mb-4 text-center fw-bold">Sign In </h2>
                        <p className="text-muted text-center mb-4">Log in to continue</p>

                        {info && (
                            <div className="alert alert-success text-center py-2">
                                {info}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} noValidate>
                            <div className="mb-3">
                                <label className="form-label">Username or Email</label>
                                <input
                                    type="text"
                                    name="username"
                                    value={form.username}
                                    onChange={handleChange}
                                    className={`form-control ${errors.username ? "is-invalid" : ""
                                        }`}
                                    placeholder="yourname or email@gmail.com"
                                />
                                {errors.username && (
                                    <div className="invalid-feedback">{errors.username}</div>
                                )}
                            </div>

                            <div className="mb-4">
                                <label className="form-label">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={form.password}
                                    onChange={handleChange}
                                    className={`form-control ${errors.password ? "is-invalid" : ""
                                        }`}
                                    placeholder="Enter your password"
                                />
                                {errors.password && (
                                    <div className="invalid-feedback">{errors.password}</div>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="btn btn-dark w-100 py-2 fw-semibold rounded-3"
                            >
                                Log In
                            </button>
                        </form>

                        <div className="text-center mt-3">
                            <span className="text-muted">Don’t have an account? </span>
                            <Link to="/signup" className="fw-semibold">
                                Sign up
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
